"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderControl = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const SliderControl = ({
  label,
  value,
  onChange,
  min,
  max,
  step = '1'
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "slider-control",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      children: [label, /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: value
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "form-range",
      type: "range",
      min: min,
      max: max,
      step: step,
      value: value,
      onChange: event => onChange(event.target.value)
    })]
  });
};
exports.SliderControl = SliderControl;